/* eslint-disable import/prefer-default-export */

export const INBOUND_PROGRAM_ACCOUNT_TYPE = {
  dealer: 'DEALER',
  fleet: 'FLEET',
  other: 'OTHER',
};



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/withCaseInboundProgram/constants.js